/**
 * Récupération de mot de passe en mode local (hors ligne).
 * Un code de récupération à usage unique (après succès) est stocké hashé.
 */
import { PasswordHasher } from '@infra/auth/PasswordHasher';

const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function generateRecoveryCode(): string {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < 8; i++) {
    out += ALPHABET[bytes[i]! % ALPHABET.length]!;
    if (i === 3) out += '-';
  }
  return out;
}

export function normalizeRecoveryCode(raw: string): string {
  return raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}

export async function hashRecoveryCode(code: string): Promise<{ hash: string; salt: string }> {
  const salt = PasswordHasher.generateSalt();
  const hash = await PasswordHasher.hash(normalizeRecoveryCode(code), salt);
  return { hash, salt };
}

export async function verifyRecoveryCode(
  code: string,
  hash: string,
  salt: string,
): Promise<boolean> {
  return PasswordHasher.verify(normalizeRecoveryCode(code), hash, salt);
}
